'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var id = require('../../id');

var DatadogSpanContext = require('../span_context');

var LogPropagator =
/*#__PURE__*/
function () {
  function LogPropagator(config) {
    _classCallCheck(this, LogPropagator);

    this._config = config;
  }

  _createClass(LogPropagator, [{
    key: "inject",
    value: function inject(spanContext, carrier) {
      if (!carrier) return;
      carrier.dd = {};

      if (spanContext) {
        carrier.dd.trace_id = spanContext.toTraceId();
        carrier.dd.span_id = spanContext.toSpanId();
      }

      if (this._config.service) carrier.dd.service = this._config.service;
      if (this._config.version) carrier.dd.version = this._config.version;
      if (this._config.env) carrier.dd.env = this._config.env;
    }
  }, {
    key: "extract",
    value: function extract(carrier) {
      if (!carrier || !carrier.dd || !carrier.dd.trace_id || !carrier.dd.span_id) {
        return null;
      }

      var spanContext = new DatadogSpanContext({
        traceId: id(carrier.dd.trace_id, 10),
        spanId: id(carrier.dd.span_id, 10)
      });
      return spanContext;
    }
  }]);

  return LogPropagator;
}();

module.exports = LogPropagator;